import React from 'react';
import { Combo } from 'fw/forms';

class DD214Status extends React.Component {
    constructor(props) {
        super(props);

        this.state = this.initialState();
    }

    initialState = () => {
        return {
            items: [
                { label: "CONFLICT", value: "CONFLICT" },
                { label: "EMPTY", value: "EMPTY" },
                { label: "PENDING", value: "PENDING" },
                { label: "SVCMEM", value: "SVCMEM" },
                { label: "VETERAN", value: "VETERAN" }
            ]
        }
    }

    render() {
        return (
            <Combo
                {...this.props}
                items={this.state.items}
                placeholder={this.props.placeholder}
                clearable={this.props.clearable}
                searchable={false} />
        )
    }
}

export default DD214Status;

// Mark this as a form component
DD214Status.defaultProps = {
	formControl: true,
	managed: false,
    clearable: true,
    placeholder: "All"
};



// WEBPACK FOOTER //
// ./src/areas/shared/controls/dd214Status/dd214Status.js